<template>
  <v-dialog
    max-width="450"
    v-model="show"
    @click:outside="handleAction('archive')"
  >
    <v-card>
      <v-card-title class="text-h5">
        <span class="text-h5">Kvittoleverans</span>
        <v-spacer></v-spacer>
      </v-card-title>
      <v-card-text style="min-height: 300px;">
        <template v-if="!isProcessingDelivery">
          <div class="d-flex justify-center mb-6">
            <v-btn
              v-if="supportsPrint"
              class="mx-4 elevation-2"
              height="100"
              width="100"
              @click="handleAction('print')"
            >
              <div class="d-flex flex-column align-center">
                <v-icon size="48" class="mb-2" color="secondary">mdi-printer</v-icon>
                <span>Skriv ut</span>
              </div>
            </v-btn>
            <v-btn
              class="mx-4 elevation-2"
              height="100"
              width="100"
              @click="handleAction('archive')"
            >
              <div class="d-flex flex-column align-center">
                <v-icon size="48" class="mb-2" color="primary">mdi-archive</v-icon>
                <span>Arkivera</span>
              </div>
            </v-btn>
          </div>

          <v-divider class="my-4"></v-divider>

          <div class="text-subtitle-1 mb-4 text-center">eller skicka till</div>

          <div class="d-flex">
            <div class="flex-grow-1">
              <v-text-field
                v-model="emailAddress"
                label="E-postadress"
                :rules="emailRules"
                prepend-icon="mdi-at"
                clearable
                outlined
              ></v-text-field>
            </div>
            <div class="ml-2">
              <v-btn
                color="primary"
                icon
                x-large
                :disabled="!isEmailValid"
                @click="handleAction('digital')"
                style="margin-top: 2px;"
              >
                <v-icon>mdi-send</v-icon>
              </v-btn>
            </div>
          </div>

          <div
            v-if="hasCashChange"
            class="cash-change d-flex align-center py-2 px-4 mt-6"
          >
            <span class="text-h6 font-weight-medium success--text">Växel tillbaka</span>
            <span class="text-h5 font-weight-bold success--text ml-auto">
              {{ cashChangeAmountFormatted }}
            </span>
          </div>
        </template>
        <div v-else class="d-flex align-center justify-center" style="height: 300px;">
          <v-progress-circular
            indeterminate
            size="90"
            color="primary"
          ></v-progress-circular>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<style lang="scss" scoped>
.cash-change {
  background-color: rgba(76, 175, 80, 0.08);
  border: 2px solid var(--v-success-base);
  border-radius: 4px;
}
</style>

<script>
import { mapState } from 'vuex'

export default {
  name: 'ReceiptDeliveryDialog',
  data: () => ({
    option: null,
    emailAddress: null,
    emailRules: [
      v => /.+@.+\..+/.test(v) || 'Ogiltig e-postadress'
    ]
  }),
  computed: {
    ...mapState(
      {
        activeReceipt: state => state.posCheckout.activeReceipt,
        cashChangeAmount: state => state.posCheckout.cashChangeAmount,
        isProcessingDelivery: state => state.posCheckout.isProcessingDelivery,
        defaultPrinter: state => state.workstation.default_printer,
        hasTerminalPrinter: state => state.posRegister.register?.payment_terminal?.has_printer
      }
    ),
    show: {
      get () {
        return this.$store.state.posCheckout.showReceiptDeliveryDialog
      },
      set (value) {
        this.$store.commit('posCheckout/SET_SHOW_RECEIPT_DELIVERY_DIALOG', value)
      }
    },
    isEmailValid: function () {
      return this.emailRules.every(rule => rule(this.emailAddress) === true)
    },
    supportsPrint: function () {
      return this.defaultPrinter || this.hasTerminalPrinter
    },
    hasCashChange: function () {
      return this.cashChangeAmount !== null
    },
    cashChangeAmountFormatted: function () {
      return window.conversion.toHumanReadableAmount(this.cashChangeAmount / 100, { roundToInteger: true })
    }
  },
  methods: {
    handleAction: function (option) {
      this.option = option
      if (option === 'digital' && !this.isEmailValid) {
        return false
      }
      this.$store.dispatch('posCheckout/confirmDelivery', {
        receiptForm: option,
        email: option === 'digital' ? this.emailAddress : null
      })
    }
  },
  watch: {
    activeReceipt: function (val) {
      if (val?.suggested_destination) {
        this.emailAddress = val.suggested_destination
      }
    },
    show: function (val, oldVal) {
      if (!val) {
        if (oldVal && !this.option) {
          this.handleAction('archive')
        }
        this.emailAddress = null
        this.option = null
      }
    }
  }
}
</script>
